import { map } from "lodash";
import { IIntakePetSectionQuestionListValue, IntakePetSectionQuestionListValue, IPhotoModel, PhotoModel } from ".";

export interface IIntakePetSectionQuestionModel {
    intakePetSectionQuestionId: number;
    intakePetSectionId: number;
    questionId: number;
    questionTypeId: number;
    name: string;
    followupQuestion: string;
    showFollowupWhenAnswerIs: boolean;
    allowMultiple: boolean;
    isReadOnly: boolean;
    sortOrder: number;
    stringValue: string;
    bitValue?: boolean;
    photoId?: number;
    yesOverrideText: string;
    noOverrideText: string;
    useMultiChoiceDropDown: boolean;
    isFollowupReadOnly: boolean;
    intakePetSectionQuestionListValues: IIntakePetSectionQuestionListValue[];
    photo?: IPhotoModel;
    questionSummary: string;
    rowVersion: string;
}

export class IntakePetSectionQuestionModel implements IIntakePetSectionQuestionModel {
    intakePetSectionQuestionId: number;
    intakePetSectionId: number;
    questionId: number;
    questionTypeId: number;
    name: string;
    followupQuestion: string;
    showFollowupWhenAnswerIs: boolean;
    allowMultiple: boolean;
    isReadOnly: boolean;
    sortOrder: number;
    stringValue: string;
    bitValue?: boolean;
    photoId?: number;
    yesOverrideText: string;
    noOverrideText: string;
    useMultiChoiceDropDown: boolean;
    isFollowupReadOnly: boolean;
    intakePetSectionQuestionListValues: IntakePetSectionQuestionListValue[] = [];
    photo?: PhotoModel | undefined;
    questionSummary: string;
    rowVersion: string;

    selectedListValueId: number | undefined;

    constructor(params: Partial<IIntakePetSectionQuestionModel> = {}) {
        const {
            intakePetSectionQuestionId = 0,
            intakePetSectionId = 0,
            questionId = 0,
            questionTypeId = 0,
            name = '',
            followupQuestion = '',
            showFollowupWhenAnswerIs = false,
            allowMultiple = false,
            isReadOnly = false,
            sortOrder = 0,
            stringValue = '',
            bitValue = undefined,
            photoId = undefined,
            yesOverrideText = "",
            noOverrideText = "",
            useMultiChoiceDropDown = false,
            isFollowupReadOnly = false,
            intakePetSectionQuestionListValues = [] as Array<IntakePetSectionQuestionListValue>,
            photo = undefined,
            questionSummary = '',
            rowVersion = ''
        } = params;

        this.intakePetSectionQuestionId = intakePetSectionQuestionId;
        this.intakePetSectionId = intakePetSectionId;
        this.questionId = questionId;
        this.questionTypeId = questionTypeId;
        this.name = name;
        this.followupQuestion = followupQuestion;
        this.showFollowupWhenAnswerIs = showFollowupWhenAnswerIs;
        this.allowMultiple = allowMultiple;
        this.isReadOnly = isReadOnly;
        this.sortOrder = sortOrder;
        this.stringValue = stringValue;
        this.bitValue = bitValue;
        this.photoId = photoId;
        this.yesOverrideText = yesOverrideText;
        this.noOverrideText = noOverrideText;
        this.useMultiChoiceDropDown = useMultiChoiceDropDown;
        this.isFollowupReadOnly = isFollowupReadOnly;
        map(intakePetSectionQuestionListValues, (lv) => { this.intakePetSectionQuestionListValues.push(new IntakePetSectionQuestionListValue(lv)); });
        this.photo = photo;
        this.questionSummary = questionSummary;
        this.rowVersion = rowVersion;

        this.selectedListValueId = this.intakePetSectionQuestionListValues.find(listVal => { return (listVal.isSelected) })?.intakePetSectionQuestionListValueId;
    }

    get photoUrl() {
        return (this.photo) ? this.photo.photoUrl : '';
    }

    // static GetIntakePetSectionQuestionModelFromQuestion(question: IQuestionModel) {
    //     return new IntakePetSectionQuestionModel({ ...question as IQuestionModel, 
    //         questionId: 0,
    //         questionTypeId: question.questionTypeId,
    //         name: question.name,
    //         isReadOnly: question.isReadOnly,
    //         isFollowupReadOnly: question.isFollowupReadOnly,
    //         followupQuestion: question.followupQuestion,
    //         showFollowupWhenAnswerIs: question.showFollowupWhenAnswerIs,
    //         allowMultiple: question.allowMultiple,
    //         yesOverrideText: question.yesOverrideText
    //     })
    // }
}
